import $ from 'jquery';

const SmoothScroll = () => {
  $(document).on('click', '.js-scroll', function(e) {
    e.preventDefault();
    const href = $(this).attr('href');
    const target = $(href);
    const position = target.offset().top;
    let shift = 0;
    if ($(this).attr('data-shift')) {
      shift = parseInt($(this).attr('data-shift'), 10);
    } else if(window.matchMedia("(width < 768px)").matches) {
      shift = -35;
    } else if(window.matchMedia("(width < 992px)").matches) {
      shift = -104;
    } else {
      shift = -135;
    }
    $('html, body').animate({
      scrollTop: position + shift,
    }, 500);
  });
}

export default SmoothScroll;